import React, { useEffect, useState } from 'react';
import { Mode } from '@src/constants';
import PersonInList from '../../../../objects/PersonInList';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import { withTranslation, useTranslation } from 'react-i18next';
import PersonListContainer from '../../../common/PersonListContainer';
import GridColumnInputWrapper from '../../../common/GridColumnInputWrapper';
import { Grid } from 'semantic-ui-react';
import CommonTagsInputWrapper from '../../../common/CommonTagsInputWrapper';
import { error } from 'console';
import { renderPersonSuggestionAddition } from '../../../Activity/components/PersonSuggestionAddition';
import { fetchCompetencyInfo, CompetencyInfoMap } from '../../../../behavior/persons/competencyApi';

type Props = {
  values: any;
  initialData: any;
  errors: any;
  mode: Mode;
  setOverridePersonState: (arg: boolean) => void;
  validateOnChange: boolean;
  setFieldValue: (arg1: string, arg2: string) => void;
  disabled: boolean;
};

const IContactListContainer = ({
  values,
  initialData,
  errors,
  mode,
  setOverridePersonState,
  validateOnChange,
  setFieldValue,
  disabled,
}: Props) => {
  const { t } = useTranslation();
  const [competencyInfoMap, setCompetencyInfoMap] = useState<CompetencyInfoMap>({});

  useEffect(() => {
    initOrgUnit();
  });

  // Fetch competency info for all contacts
  useEffect(() => {
    const personIds = (values.contacts || [])
      .map((c: any) => c.person?.id)
      .filter((id: any) => id != null);
    if (personIds.length > 0) {
      fetchCompetencyInfo(personIds).then(setCompetencyInfoMap);
    }
  }, [values.contacts?.length]);

  const getOrgUnitAsEntity = (orgUnitName: string) => {
    return { name: orgUnitName };
  };

  const getOrgUnitDepAndGroup = (orgUnit: string) => {
    return orgUnit.split('-', 2).join('-');
  };

  useEffect(() => {
    const { contacts } = values;

    if (contacts.length > 0) {
      let newFirstPersonDep = contacts[0].person.orgUnit
        ? getOrgUnitDepAndGroup(contacts[0].person.orgUnit)
        : null;

      if (newFirstPersonDep) {
        values.orgUnit = getOrgUnitAsEntity(newFirstPersonDep);
      }
    }
  }, values.contacts.length);

  const initOrgUnit = () => {
    if (!values.orgUnit)
      if (values.contacts && values.contacts.length > 0 && values.contacts[0].person.orgUnit) {
        let newOrgUnit = getOrgUnitDepAndGroup(values.contacts[0].person.orgUnit);
        values.orgUnit = { name: newOrgUnit };
      } else values.orgUnit = null;
  };

  const getContactListContainerContent = () => {
    return (
      <>
        <Grid stackable columns={1} verticalAlign="bottom">
          <GridColumnInputWrapper
            name="orgUnit"
            label="inventory.details.page.contact.list.container.org.unit.input"
            specialRequiredCondition={true}
            setFieldValue={setFieldValue}
            disabled={disabled}
            render={(props: any) => (
              <CommonTagsInputWrapper
                {...props}
                suggestionList={initialData.orgUnitList}
                matchProperty="name"
                displayProps="name"
                value={values.orgUnit}
                maxTags={1}
                onlyUnique={true}
              />
            )}
          />
        </Grid>
        <PersonListContainer
          values={values}
          newPersonEntity={PersonInList}
          arrayPropName="contacts"
          fieldPropName="person"
          showEmailHandler={true}
          showNoEmailAvailable={true}
          showDeleteHandler={true}
          showAddNew={true}
          sort={true}
          isNotMissingCompetencies={false}
          blockExpiredSelection={true}
          renderSuggestionAddition={(obj: any) => renderPersonSuggestionAddition(obj, t)}
          showNotPresentAtCernWarning
          showExpiredCompetencyWarning
          competencyInfoMap={competencyInfoMap}
          errors={errors}
          mode={mode}
          setOverridePersonState={setOverridePersonState}
          validateOnChange={validateOnChange}
          disabled={disabled}
        />
      </>
    );
  };

  return (
    <AccordionWrapper
      closable={false}
      accordionTitle="inventory.details.page.contact.list.container.title"
      tooltip="inventory.details.page.contact.list.container.tooltip"
      render={getContactListContainerContent}
      className=""
      isRequired={true}
    />
  );
};

export default withTranslation()(IContactListContainer);
